import Service from '../../service/Service';
import Cookies from "js-cookie";

import { createElement } from 'react';
const service = new Service();
var jcrop_api;
var mealcourse = [];
var cookingmethod = [];
var mealschedule = [];
var byAge = [];
var typeofmeal = [];
var checkedparent, subcat_count;
var allergen = [];
var season = [];
var region = [];
var cooktime = [];
var filterCount1 = 0;


export function scrollToTop() {
    let element = document.documentElement;
    let to = 0;
    let duration = 500;

    var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;
    var easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    };

    var animateScroll = function () {
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

export function shareOn(e, id, isApp, recipeImg, recipeName, flag , desc , rcipeId, mealId,mealRecp) {

    if (isApp) {
        if (recipeName) {
            var shareText = recipeName;
        } else {
            // sample text for share
            var shareText = "";
        }
        if (recipeImg) {
            var thmbnailurl = recipeImg;
        } else {
            var thmbnailurl = "";
        }
        // var shrtxt = (flag=="review") ? " review " : " recipe ";
        var recName= service.genquestionurl(recipeName);
        if (recipeName != "Mother's Milk/Formula Feed" && rcipeId != '') {
            if (flag == "MealLanding") {
                if (recipeName != "Mother's Milk/Formula Feed" && rcipeId != '') {
                    Cookies.set("resipeId", rcipeId);
                    Cookies.set("RecipeList", flag);
                    Cookies.set("mealId", mealId);
                    var redirect_recipeD = "/tools/baby-meal-plan/" + recName.trim().replace(/ /g, "-").replace(/\//g, " ").toLowerCase() + "?meal=" + mealId +"&recId="+ rcipeId;
                }
            } else {
                var redirect_recipeD = "/tools/baby-meal-plan/" + recName.trim().replace(/ /g, "-").replace(/\//g, " ").toLowerCase() + "?recId="+ rcipeId;
            }
        }
        if(flag=="recipeDetails" || flag=="review" || flag=="GorceryList"){
            var articleurl = window.location.href;
        }else{
            var redirectUrl = window.location.origin + service.getRedirectUrl(redirect_recipeD);
            var articleurl = redirectUrl;
        }
        if(flag=="recipeDetails"){
            var shareTXT = recipeName + ' \nRating: '+mealRecp.ratingpercentcount +'\n'+recName+'\n'+desc && desc.slice(0,300)+'Allergen Info :'+mealRecp.allergen+'\n Season : '+mealRecp.seasonName;
        }else if(flag == "GorceryList"){   
            var arr = [];
            for(var i=0;i<4;i++){
                if(mealRecp && mealRecp.list[i]!=undefined){
                    arr.push(mealRecp.list[i].ingredient);arr.push("\n");
                }
            }     
            var shareTXT = recipeName +'  \n' + arr.toString() ;
        }else{
            var shareTXT = recipeName +' \nRating: '+mealRecp.ratingpercentcount +'\n'+recName+'\n'+desc && desc.slice(0,300)+'Allergen Info :'+mealRecp.allergenInfo+'\n Season : '+mealRecp.seasonName;
        }
        // var deepjson = {
        //     "appurl": [{
        //         "pagetype": "share",
        //         "shareText": shareTXT,
        //         "thumbnailUrl": thmbnailurl,
        //         "shareUrl": articleurl,
        //         "desc": desc && desc.slice(0,300),
        //         "title": shareText
        //     }]
        // };
        // service.jsontracker(JSON.stringify(deepjson));
        let mealCategoryElement = document.querySelector(".selected-meal .meal-type");
        let meal_category = mealCategoryElement ? mealCategoryElement.innerText.trim() : "";

        let toggleElement = document.querySelector(".online-toggle");
        let isToggleSet = toggleElement ? (toggleElement.classList.contains("show-non-veg") ? "Off" : "On") : "";

        let season = e.target.closest(".mealrecipe-main")?.querySelector(".season-text")?.innerHTML.trim() || "";
        let day = e.target.closest(".mealrecipe-main")?.querySelector(".meal-menu-days")?.innerHTML.trim() || "";
        // Remove <span> and its contents
        day = day.replace(/<span[^>]*>.*?<\/span>/gi, "").trim();

        let flagValue;
        if(flag == "MealLanding"){
            flagValue = "baby meal palnner"
        }


        if(flag == "Recipe"){
            flagValue = "recipe"
        }

        if(flag == "bookmarks" || flag == "Bookmarks"){
            flagValue = "bookmark"
        }

        if(flag == "recipeDetails"){
            
            let appMXPJson = {
                "appurl": [
                    {
                        "pagetype": "share",
                        "shareText": shareTXT,
                        "shareUrl": articleurl,
                        "desc": desc && desc.slice(0,300),
                      "webengageEvent": {
                        "eventname": "bmp_detail_page_actions",
                        "eventdata": {
                        "recipe_id": rcipeId,
                        "recipe_name": recipeName,
                        "action_type":"shared",
                        "shared_platform":"",
                        "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_detail_page_actions",
                        "eventdata": {
                        "recipe_id": rcipeId,
                        "recipe_name": recipeName,
                        "action_type":"shared",
                        "shared_platform":"",
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appMXPJson));

        }
        if(flag == "bookmarks" || flag == "Bookmarks" || flag == "Recipe" || flag == "MealLanding"){
            let appMXPJson = {
                "appurl": [
                    {
                        "pagetype": "share",
                        "shareText": shareTXT,
                        "shareUrl": articleurl,
                        "desc": desc && desc.slice(0,300),
                      "webengageEvent": {
                        "eventname": "bmp_homepage_actions",
                        "eventdata": {
                        "meal_category": meal_category,
                        "veg_toggle": isToggleSet,
                        "recipe_id":rcipeId,
                        "recipe_name":recipeName,
                        "season":season,
                        "day":day,
                        "shared_platform":"",
                        "article_id":'',
                        "article_name":'',
                        "action_type": "shared",
                        "page_type":flagValue,
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_homepage_actions",
                        "eventdata": {
                        "meal_category": meal_category,
                        "veg_toggle": isToggleSet,
                        "recipe_id":rcipeId,
                        "recipe_name":recipeName,
                        "season":season,
                        "day":day,
                        "shared_platform":"",
                        "article_id":'',
                        "article_name":'',
                        "action_type": "shared",
                        "page_type":flagValue,
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appMXPJson));
        }
          
        if(flag == "GorceryList"){
            
            let appMXPJson = {
                "appurl": [
                    {
                        "pagetype": "share",
                        "shareText": shareTXT,
                        "shareUrl": articleurl,
                        "desc": "",
                        "recipe_id": mealRecp.recipeid,
                        "recipe_name": mealRecp.recname,
                        "webengageEvent": {
                            "eventname": "grocery_list_page_actions",
                            "eventdata": {
                            "recipe_id": mealRecp.recipeid,
                            "recipe_name": mealRecp.recname,
                            "action_type":"shared",
                            "shared_platform":"",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                            }
                        },
                        "jarvisEvent": {
                            "eventname": "grocery_list_page_actions",
                            "eventdata": {
                            "recipe_id": mealRecp.recipeid,
                            "recipe_name": mealRecp.recname,
                            "action_type":"shared",
                            "shared_platform":"",
                            }
                        }
                    }
                ]
            }; 
                service.jsontracker(JSON.stringify(appMXPJson));
        }
        
        var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
        var eventName = (flag=="MealLanding") ? 'Meal Planner| ' + loginStatus + '|Homepage Actions' : (flag=="review") ? 'Meal Planner | Review Page Actions' : (flag=="recipeDetails") ? 'Meal Planner | Recipe Detail Page Actions' : (flag=="GorceryList") ? 'Meal Planner|Grocery List Page Actions' : (flag=="bookmarks") ? 'Meal Planner|Bookmark Page Actions' : 'Meal Planner | Listing Page Actions';
        var eventAction = (flag=="MealLanding") ? 'Recipe Share' : 'Share';
        var obj={};
        obj.gaObj = eventName + '_' + eventAction;
            // "eventdata": {
            //     "event_action": eventAction,
            //     "event_label": ""
            // }
        trackEvent(obj);
    } else {
        let ary = document.querySelectorAll(".sharing-options");
        for (var i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (window.innerWidth < 767) {
            // e.target.nextSibling.style.display = 'block';
            document.querySelector("#share_" + id).style.display = 'block';
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
        document.querySelector("#share_" + id).style.display = 'block';
        // id.target.nextSibling.style.display = 'block';
    }
}


export function shareList(e, shareoption) {
    document.querySelector('.sharing-options').style.display = 'none';
    var urlpath = window.location.href;

    var collectionId = window.location.pathname.split('/')[3];
    // if (collectionId) {
    //     var articleurl = window.location.href;
    // } else {
    var articleurl = window.location.href;
    // }
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    var shareurl;
    if (shareoption == "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption == "google") {
        shareurl = 'https://plus.google.com/share?url=';
    } else if (shareoption == "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption == "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption == "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }

    document.querySelector('.share-overlay').style.display = "none";

    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}

export function domClick(event) {
    if (!event.target.classList.contains('abuse_icon')) {
        let ary = document.getElementsByClassName('abuse-tooltip');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
    }

    if (!event.target.classList.length > 0 && !event.target.classList.contains('share-icon') && !event.target.classList.contains('share-text') && !event.target.classList.contains('share-container') && !event.target.classList.contains("shareIcon") && !event.target.classList.contains("M14_9e") && !event.target.classList.contains("whatsappIcon") && !event.target.classList.contains("fbimg")) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (event.target.classList.contains('share-overlay')) {
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        }
        document.getElementsByTagName("body")[0].style.overflow = "auto";
    }

    if (!event.target.classList.contains('editDeleteIcon')) {
        [].forEach.call(document.querySelectorAll(".editOptions"), function (ele) {
            ele.style.display = "none";
        })
    }
    if (event.target.classList.contains("collection-list-popup") && !event.target.classList.contains("collection") && !event.target.classList.contains("next") && !event.target.classList.contains("prev")) {

        document.querySelector(".collection-list-popup").style.display = "none";
        document.getElementsByTagName("body")[0].style.overflow = "auto";
        [].forEach.call(document.querySelectorAll(".openpopup"), function (elem) {

            elem.className = elem.className.replace(/\openpopup\b/, "");
        })
    }
    if (!event.target.classList.contains("sort-ic") && !event.target.classList.contains("sort_filter_text") && !event.target.classList.contains("sort_cont") && !event.target.classList.contains("sort-menu")) {
        if (document.querySelector(".sort-list-popup")) {
            document.querySelector(".sort-list-popup").style.display = "none";
        }
    }
    if (event.target.classList.contains('childProfile_overlay2')) {
        document.getElementsByClassName('childProfile_overlay2')[0].style.display = 'none';
    }
    if (event.target.classList.contains('filter-overlay')) {
        document.getElementsByClassName('filter-overlay')[0].style.display = 'none';
        document.querySelector('body').style.overflow="visible";
        if (window.innerWidth < 767 && document.getElementsByClassName('toggle-main') && document.getElementsByClassName('toggle-main')[0]) {
            document.getElementsByClassName('toggle-main')[0].style.display = 'block';
        }
    }
}

export function slideStage(e, eleRef, slider) {
    if (navigator.onLine) {
        if (e.target.parentElement.classList.contains('next')) {
            document.querySelector("." + slider).scrollLeft = (document.querySelector("." + slider).scrollLeft + 114);
            eleRef.state.myactiveStage += 114;
        } else {
            document.querySelector("." + slider).scrollLeft = document.querySelector("." + slider).scrollLeft - 114;
            eleRef.state.myactiveStage -= 114;
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}
export function removeSelfClass(add, remove) {
    // setTimeout(() => {
    let count = document.querySelectorAll('.' + add).length;
    for (let i = 0; i < count; i++) {
        document.querySelectorAll('.' + add)[i].classList.add(remove);
    }
    let count1 = document.querySelectorAll('.' + remove).length;
    for (let j = 0; j < count1; j++) {
        document.querySelectorAll('.' + remove)[j].classList.remove(add);
    }
    // }, 1000);
}
export function shareArticle(shareoption, articleurl, rcipeId, recName) {
    var shareurl;
    if (articleurl != 'Meal') {
        articleurl = global.currentURL;
    } else {
        articleurl = global.redirect_url + "tools/baby-meal-plan/" + recName.trim().replace(/ /g, "-").replace(/\//g, " ") + "?" + rcipeId + "/";
    }
    if (!articleurl.includes('http')) {
        // articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if (document.getElementsByClassName('share-overlay') && document.getElementsByClassName('share-overlay')[0]) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption === "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption === "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption === "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption === "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}


export function recipeDetails(flag, id, rcipeId, recName, isApp, pagetype, recipeType, e) {
    const showDebug = (msg) => {
        const el = document.createElement("div");
        el.innerText = typeof msg === "object" ? JSON.stringify(msg) : msg;
        el.style.position = "fixed";
        el.style.top = "0";
        el.style.left = "0";
        el.style.width = "100%";
        el.style.background = "black";
        el.style.color = "white";
        el.style.zIndex = "999999";
        el.style.fontSize = "12px";
        el.style.padding = "5px";
        document.body.appendChild(el);
      };
    console.log("Meal planner recipeDetails Ftk========>", global.ftk);
    // showDebug("✅ global.ftk :", global.ftk);

    var recipeName= service.genquestionurl(recName);
    if(isApp){

        if(flag=="MealLanding"){
            let mainContainer = e.target.closest(".mealrecipe-main");
            let menuDays = mainContainer?.querySelector(".meal-menu-days");
            let isToggleSet;
                if(document.querySelector(".online-toggle").classList.contains("show-non-veg")){
                    isToggleSet="Off";
                }else{
                    isToggleSet="On";
                }
            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                        "veg_toggle": isToggleSet,
                        "recipe_id":rcipeId,
                        "recipe_name":recName,
                        "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                        "day":menuDays ? menuDays.innerHTML : '',
                        "shared_platform":"",
                        "article_id":"",
                        "article_name":"",
                        "action_type": "recipe click",
                        "page_type":"baby meal palnner"
                      },
                      "webengageEvent": {
                        "eventname": "bmp_homepage_actions",
                        "eventdata": {
                            "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                            "veg_toggle": isToggleSet,
                            "recipe_id":rcipeId,
                            "recipe_name":recName,
                            "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                            "day":menuDays ? menuDays.innerHTML : '',
                            "shared_platform":"",
                            "article_id":"",
                            "article_name":"",
                            "action_type": "recipe click",
                            "page_type":"baby meal palnner",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_homepage_actions",
                        "eventdata": {
                            "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                            "veg_toggle": isToggleSet,
                            "recipe_id":rcipeId,
                            "recipe_name":recName,
                            "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                            "day":menuDays ? menuDays.innerHTML : '',
                            "shared_platform":"",
                            "article_id":"",
                            "article_name":"",
                            "action_type": "recipe click",
                            "page_type":"baby meal palnner"
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));
        }

        if(flag == "MealLanding" || pagetype=="BookMark"){
            var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
            var eventName =(flag == "MealLanding")?'Meal Planner| ' + loginStatus + '|Homepage Actions':(pagetype=="BookMark")?'Meal Planner|Bookmark Page Actions':'';
            var eventAction =(flag == "MealLanding")?'Recipe Click':(pagetype=="BookMark")?'Click':'';
    
            var obj={};
            obj.gaObj = eventName + '_' + eventAction;
            obj.webengageObj = {
                "eventname": "view_diet_plan_article_6months",
                "eventdata": {
                  "article_id": rcipeId,
                  "child_id":  Cookies.get("mealChild_id") ? Cookies.get("mealChild_id") : '',
                  "child_name": Cookies.get("mealChildName") ? Cookies.get("mealChildName") : '' 
                }
            }
            
            trackEvent(obj);
            obj.webengageObj = {
                "eventname": "receipe_viewed",
                "eventdata": {
                  "meal_name": recName,
                  "category_name": recipeType ? recipeType : '',
                  "category_id":  "",
                  "baby_age_in_months": Cookies.get("mealChildMonth") ? Cookies.get("mealChildMonth") : '' 
                }
            }
            trackEvent(obj);
        }else{
            var obj={};
            obj.gaObj = "";
            obj.webengageObj = {
                "eventname": "view_diet_plan_article_6months",
                "eventdata": {
                  "article_id": rcipeId,
                  "child_id":  Cookies.get("mealChild_id") ? Cookies.get("mealChild_id") : '',
                  "child_name": Cookies.get("mealChildName") ? Cookies.get("mealChildName") : '' 
                }
            }
            trackEvent(obj);
            obj.webengageObj = {
                "eventname": "receipe_viewed",
                "eventdata": {
                  "meal_name": recName,
                  "category_name": "",
                  "category_id":  "",
                  "baby_age_in_months": Cookies.get("mealChildMonth") ? Cookies.get("mealChildMonth") : '' 
                }
            }
            trackEvent(obj);

        }
    }
    if (recName != "Mother's Milk/Formula Feed" && rcipeId != '') {
        if (flag == "MealLanding") {
            if (recName != "Mother's Milk/Formula Feed" && rcipeId != '') {
                Cookies.set("resipeId", rcipeId);
                Cookies.set("RecipeList", flag);
                Cookies.set("mealId", id);
                var redirect_recipeD = "/tools/baby-meal-plan/" + recipeName.trim().replace(/ /g, "-").replace(/\//g, " ").toLowerCase() + "?meal=" +id +"&recId="+ rcipeId;
                // window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/" + recipeName.trim().replace(/ /g, "-").replace(/\//g, " ").toLowerCase() + "?" + rcipeId);
            }
        } else {
            var redirect_recipeD = "/tools/baby-meal-plan/" + recipeName.trim().replace(/ /g, "-").replace(/\//g, " ").toLowerCase() + "?recId="+ rcipeId;
            // window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/" + recipeName.trim().replace(/ /g, "-").replace(/\//g, " ").toLowerCase() + "?" + rcipeId);
        }
    }
    if (global.ftk != '') {
         window.location.href = service.getRedirectUrl(redirect_recipeD);
    } else {
        if (isApp) {
            showDebug(" ❌ global.ftk NOT FOUND");

            // var redirectUrl = window.location.origin + service.getRedirectUrl(redirect_recipeD);
            // window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + redirectUrl);
            // loginCallBack(redirectUrl);
        } else {
            service.showAlert("Please Login");
            var redirectUrl = window.location.origin + service.getRedirectUrl(redirect_recipeD);
            window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + redirectUrl);
            return false;
        }
    }

}
export function showSubCat(category) {
    var allList = document.querySelector(".categorieslist").children;
    for (var i = 0; i < allList.length; i++) {
        allList[i].classList.remove("active");
    }
    document.getElementsByClassName("cls_" + category)[0].classList += " active";
    var subLists = document.querySelector(".subcategory_list").children;

    for (var j = 0; j < subLists.length; j++) {
        subLists[j].classList.remove("active");
    }
    document.querySelector(".sub" + category).classList += " active";
}
export function checkfiltersubcat(event) {
    event.preventDefault();
    var children_classarray = event.currentTarget.children;
    if (children_classarray[0].classList.contains('isChecked')) {
        children_classarray[0].classList.remove("isChecked");
        children_classarray[1].classList.remove("isChecked");
        children_classarray[0].setAttribute("data-icon-font", "z");
    } else {
        children_classarray[0].classList += " isChecked";
        children_classarray[1].classList += " isChecked";
        children_classarray[0].setAttribute("data-icon-font", "A");
    }
    if (Cookies.get('Meal_filters') == "true") {
        var el = event.target.parentElement;
        while (el.className.split(" ")[1] != 'subcategorieslist') {
            el = el.parentElement;
        }
        checkedparent = el.classList;

        subcat_count = document.querySelector("." + checkedparent[0]).querySelectorAll(".subcatname.isChecked").length;

        if (subcat_count > 0) {
            document.querySelector(".categorieslist").querySelector(".active").querySelector(".subcatCount").innerHTML = (subcat_count + " Selected");
        }
        else {
            document.querySelector(".categorieslist").querySelector(".active").querySelector(".subcatCount").innerHTML = '';
        }
    }
}
export function clearAll(event, eleRef, isApp) {
    sessionStorage.setItem('mealfilterCount1',0)
    Cookies.set('mealfilterCount',0);
    if(isApp){
        var ScreenName='Recipe Listing ';
        var eventName ='Meal Planner |'+ ScreenName +'Filter Actions';
        var obj={};
        obj.gaObj = eventName + '_Clear All';
            // "eventdata": {
            //   "event_action": "Clear All",
            //   "event_label": ""
            // }
          trackEvent(obj);
    }
    event.preventDefault();
    eleRef.setState({ filterCount: 0 });
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    var el = event.target.parentElement;

    while (el.className.split(" ")[1] != 'overlay') {
        el = el.parentElement;
    }

    var all_filters_list = el.getElementsByClassName('filter_popups')[0].getElementsByClassName('subcategorieslist');

    for (var j = 0; j < all_filters_list.length; j++) {

        var inputs = all_filters_list[j].getElementsByTagName('li');
        for (var i = 0; i < inputs.length; i++) {

            var elems = inputs[i].querySelectorAll(".isChecked");
            [].forEach.call(elems, function (el) {
                el.className = el.className.replace(/\isChecked\b/, "");
            });

            inputs[i].getElementsByClassName('check')[0] && inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "z");
        }
    }
    var _selectedtext = document.querySelectorAll(".subcatCount");

    [].forEach.call(_selectedtext, function (el) {
        if (el.innerHTML != '') {
            el.innerHTML = '';
        }
    });

    var _prefilterpopups = document.querySelectorAll(".filter_popups");

    for (var j = 0; j < _prefilterpopups.length; j++) {

        var inputs = _prefilterpopups[j].getElementsByTagName('li');

        for (var i = 0; i < inputs.length; i++) {

            if (inputs[i].classList.contains("applied")) {
                inputs[i].className = inputs[i].className.replace(/\applied\b/, "");
                var _elems = inputs[i].querySelectorAll(".isChecked");
                [].forEach.call(_elems, function (el) {
                    el.className = el.className.replace(/\isChecked\b/, "");
                });

                inputs[i].getElementsByClassName('check')[0] && inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "z");
            }
        }
    }

}
export function applyfilter(event, filterCount, eleRef, isApp) {
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    applyFilteronCat(event, byAge, "subby0", "Byages", filterCount, eleRef);
    applyFilteronCat(event, mealschedule, "submeal1", "Meal Schedule", filterCount, eleRef);
    applyFilteronCat(event, typeofmeal, "subtype2", "Type of Meal", filterCount, eleRef);
    applyFilteronCat(event, mealcourse, "submeal3", "Meal course", filterCount, eleRef);
    applyFilteronCat(event, cookingmethod, "subcooking4", "Cooking Method", filterCount, eleRef);
    applyFilteronCat(event, cooktime, "subcooking5", "Cooking Time", filterCount, eleRef);
    applyFilteronCat(event, allergen, "suballergen6", "Allergen", filterCount, eleRef);
    applyFilteronCat(event, season, "subseason7", "Season", filterCount, eleRef);
    applyFilteronCat(event, region, "subregion8", "Region", filterCount, eleRef);

    // Cookies.set('mealcourse', mealcourse);
    // Cookies.set('cookingmethod', cookingmethod);
    // Cookies.set('mealschedule', mealschedule);
    // Cookies.set('byAge', byAge);
    // Cookies.set('typeofmeal', typeofmeal);
    // Cookies.set('allergen', allergen);
    // Cookies.set('season', season);
    // Cookies.set('region', region);
    // Cookies.set('cooktime', cooktime);

    localStorage.setItem('mealcourse', mealcourse);
    localStorage.setItem('cookingmethod', cookingmethod);
    localStorage.setItem('mealschedule', mealschedule);
    localStorage.setItem('byAge', byAge);
    localStorage.setItem('typeofmeal', typeofmeal);
    localStorage.setItem('allergen', allergen);
    localStorage.setItem('season', season);
    localStorage.setItem('region', region);
    localStorage.setItem('cooktime', cooktime);

    let postData;
    let url = global.api_ci_url + "MealPlanner/getReceipeFilter";
    // let url = global.api_url + "dietplan/getreceipefilter";
    postData = {
        "pageno": 1,
        "pagesize": 10,
        "mealcourse": mealcourse,
        "cookingmethod": cookingmethod,
        "mealschedule": mealschedule,
        "byAge": byAge,
        "typeofmeal": typeofmeal,
        "allergen": allergen,
        "season": season,
        "region": region,
        "cooktime": cooktime
    }
    let postDataGA = {
        "mealcourse": mealcourse,
        "cookingmethod": cookingmethod,
        "mealschedule": mealschedule,
        "byAge": byAge,
        "typeofmeal": typeofmeal,
        "allergen": allergen,
        "season": season,
        "region": region,
        "cooktime": cooktime
    }
    if(isApp){
        var ScreenName='Recipe Listing';
        var eventName ='Meal Planner |'+ ScreenName +'Filter Actions';
        var eventAction = "Apply";
        var eventLable= JSON.stringify(postDataGA);
        var obj={};
        obj.gaObj = eventName+'_'+eventAction+'_'+eventLable;
            // "eventdata": {
            //   "event_action": eventAction,
            //   "event_label": eventLable
            // }
        trackEvent(obj);
    }
    service.postServiceCall(url, postData).then((json) => {
        console.log("json =====", json);
        if (json['msg'] == "1") {
            // clearAll(event);
            if (json['result'].length < 1) {
                document.querySelector(".recipebanner").style.display = "none";
                document.querySelector(".disclaimer-con").style.display = "none";
                document.querySelector(".recipeBlock").style.display = "none";
                eleRef.setState({norecordFoundFilter:true});
                document.querySelector('.NoRecordsCont').style.display = "block";
                document.querySelector('.NoRecordsCont') && (document.querySelector('.main-container').style.background="#fff");
                var scheight = screen.height -80 - 55;
                document.querySelector('.NoRecordsCont') && (document.querySelector('.sub-container').style.height= scheight+"px");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.minHeight="auto");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.height="100%");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.height="100%");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.padding="42% 1px");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.background = "#fff");
                
                // service.showAlert("Record not found");
            }else if (json['result'].length <= 2) {
                document.querySelector('.main-container').style.background = "#eee";
                document.querySelector('.disclaimer-con').style.width = "100%";
                document.querySelector('.disclaimer-con').style.position = "fixed";
                document.querySelector('.recipeBlock').style.border = "none";
                document.querySelector('.data-container').style.background = "#fff";
                document.querySelector('.disclaimer-con').style.bottom = "40px";
                document.querySelector('.disclaimer-con').style.marginBottom = "0px";
                // document.querySelector('.disclaimer-con').style.paddingBottom = "39px";
                var scheight = screen.height - 80 - 55;
                document.querySelector('.sub-container') && (document.querySelector('.sub-container').style.height = scheight + "px");
            }else{
                // document.querySelector('.disclaimer-con').style.width = "100%";
                document.querySelector('.disclaimer-con').style.paddingBottom = "39px";
                document.querySelector('.disclaimer-con').style.marginBottom = "35px";
                document.querySelector('.disclaimer-con').style.position = "unset";
                document.querySelector('.disclaimer-con').style.bottom = "0px";
                document.querySelector('.main-container') && (document.querySelector('.main-container').style.background="#fff");
                document.querySelector('.sub-container').style.height = "auto";
            }
            eleRef.setState({ mealSelRecp: json['result'], filterCount: filterCount1 },eleRef.onclosePopup());
            Cookies.set('mealfilterCount', filterCount1);
            sessionStorage.setItem('mealfilterCount1', filterCount1);
            if(json['result'].length < 1){
                Cookies.set('mealfilterCount',0);
                sessionStorage.setItem('mealfilterCount1',0);
            }
            filterCount1 = 0;
            eleRef.qnaPageNo = 1;
            eleRef.maxScroll = 0;
            // mealcourse = [];
            // cookingmethod = [];
            // mealschedule = [];
            // byAge = [];
            // typeofmeal = [];
            // allergen = [];
            // season = [];
            // region = [];
            // cooktime = [];
        }
        service.hideLoader();
        service.hideTracking();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
        service.hideTracking();
    });
    Cookies.set('Meal_filters', false);

}

function applyFilteronCat(event, catvalArr, subcat, catName, count, eleRef) {
    [].forEach.call(document.querySelectorAll("." + subcat), function (el) {
        var isChecked = el.querySelectorAll(".R14_42.isChecked");
        if (isChecked.length > 0) {
            catvalArr = [];
            for (var i = 0; i < isChecked.length; i++) {
                isChecked[i].parentElement.className = isChecked[i].parentElement.className.replace(/\applied\b/, "");
                // isChecked[i].previousSibling.setAttribute("data-icon-font", "z");
                isChecked[i].parentElement.classList += " applied";

                if (subcat == "subcooking5") {
                    var onlycatg = isChecked[i];

                    var onlysecond = onlycatg.innerHTML.split("within ")[1].split(" ");
                    if (onlysecond[1] == "mins") {
                        var stringSpli = onlysecond[0] + 'min';
                    } else {
                        var stringSpli = onlysecond[0] + 'hr';
                    }
                    catvalArr.push(stringSpli);

                } else {
                    var onlycatg = isChecked[i];

                    var onlysecond = onlycatg.innerHTML;

                    catvalArr.push(onlysecond);
                }

            }

        } else {
            catvalArr = [];
            [].forEach.call(el.querySelectorAll("li"), function (elem) {
                elem.className = elem.className.replace(/\applied\b/, "");
                [].forEach.call(elem.querySelectorAll(".icon"), function (element) {
                    element.setAttribute("data-icon-font", "z");
                });
            })
        }
    })

    if (catvalArr.length > 0) {
        filterCount1++;
    }
    if (catName == "Byages") {
        // filterCount1++;
        byAge = catvalArr
    } else if (catName == "Meal Schedule") {
        // filterCount1++;
        mealschedule = catvalArr
    } else if (catName == "Type of Meal") {
        // filterCount1++;
        typeofmeal = catvalArr
    } else if (catName == "Meal course") {
        // filterCount1++;
        mealcourse = catvalArr
    } else if (catName == "Cooking Method") {
        // filterCount1++;
        cookingmethod = catvalArr
    } else if (catName == "Cooking Time") {
        // filterCount1++;
        cooktime = catvalArr
    } else if (catName == "Allergen") {
        // filterCount1++;
        allergen = catvalArr
    } else if (catName == "Season") {
        // filterCount1++;
        season = catvalArr
    } else {
        // filterCount1++;
        region = catvalArr;
    }
}

export function filterToCategory(subCategory, sessionKey) {
    if (localStorage.getItem(sessionKey)) {
        var categoryCookie = localStorage.getItem(sessionKey).split(",");
        [].forEach.call(document.querySelector(".recipe-list-cont").querySelector(".filter-overlay").querySelector("." + subCategory).querySelectorAll(".subcatname"), function (value, key) {

            if (categoryCookie.length >= 1) {

                [].forEach.call(categoryCookie, function (result, index) {
                    if (subCategory == "subcooking5") {
                        var onlysecond = value.innerHTML.split("within ")[1].split(" ");
                        if (onlysecond[1] == "mins") {
                            var stringSpli = onlysecond[0] + 'min';
                        } else {
                            var stringSpli = onlysecond[0] + 'hr';
                        }
                        if (stringSpli.toLowerCase() == result.toLowerCase()) {
                            if (!value.classList.contains("isChecked")) {
                                value.classList += " isChecked";
                            }
                            if (!value.previousSibling.classList.contains("isChecked")) {
                                value.previousSibling.classList += " isChecked";
                            }

                            value.previousSibling.setAttribute("data-icon-font", "A");

                            if (!value.parentElement.classList.contains("applied")) {
                                value.parentElement.classList += " applied";
                            };
                        }
                    } else {
                        if (value.innerHTML.toLowerCase() === result.toLowerCase()) {
                            if (!value.classList.contains("isChecked")) {
                                value.classList += " isChecked";
                            }
                            if (!value.previousSibling.classList.contains("isChecked")) {
                                value.previousSibling.classList += " isChecked";
                            }
                            value.previousSibling.setAttribute("data-icon-font", "A");
                            if (!value.parentElement.classList.contains("applied")) {
                                value.parentElement.classList += " applied";
                            };
                        }
                    }
                })
            }

            // else {

            //     if (subCategory == "subrashi") {
            //         var _rashi = value.innerHTML.split(" ");
            //         var onlyrashi = _rashi[0];
            //         var _rashicookie = categoryCookie[0].split(" ");
            //         var onlycookierashi = _rashicookie[0];
            //         if (onlyrashi.toLowerCase() == onlycookierashi.toLowerCase()) {
            //             if(!value.classList.contains("isChecked")){
            //                 value.classList += " isChecked";
            //             }
            //             if(!value.parentElement.classList.contains("isChecked")){
            //                 value.parentElement.classList += " isChecked";
            //             }


            //             value.parentElement.querySelector(".icon").setAttribute("data-icon-font", "A");
            //             if(!value.parentElement.querySelector(".icon").classList.contains("isChecked")){
            //                 value.parentElement.querySelector(".icon").classList += " isChecked";
            //             }

            //             if(!value.parentElement.classList.contains("applied")) {
            //                 value.parentElement.classList += " applied";
            //             };
            //         }
            //     } else if (subCategory == "subnakshatra") {
            //         var _nakshatra = value.innerHTML.split(" ");
            //         var onlynakshatra = _nakshatra[0];
            //         var _nakshatracookie = categoryCookie[0].split(" ");
            //         var onlycookienakshatra = _nakshatracookie[0];

            //         if (onlynakshatra.toLowerCase() == onlycookienakshatra.toLowerCase()) {
            //             if(!value.classList.contains("isChecked")){
            //                 value.classList += " isChecked";
            //             }
            //             if(!value.parentElement.classList.contains("isChecked")){
            //                 value.parentElement.classList += " isChecked";
            //             }

            //             value.parentElement.querySelector(".icon").setAttribute("data-icon-font", "A");
            //             if(!value.parentElement.querySelector(".icon").classList.contains("isChecked")){
            //                 value.parentElement.querySelector(".icon").classList += " isChecked";
            //             }

            //             if(!value.parentElement.classList.contains("applied")) {
            //                 value.parentElement.classList += " applied";
            //             };
            //         }
            //     } else {

            //         if(categoryCookie[0].includes("-")){
            //             categoryCookie[0] = capitalize(categoryCookie[0].split("-")[0]) + " " + capitalize(categoryCookie[0].split("-")[1]);

            //         } else {
            //             categoryCookie[0] = categoryCookie[0];
            //         }

            //         if (value.innerHTML.toLowerCase() == categoryCookie[0].toLowerCase()) {

            //             if(!value.classList.contains("isChecked")){
            //                 value.classList += " isChecked";
            //             }
            //             if(!value.previousSibling.classList.contains("isChecked")){
            //                 value.previousSibling.classList += " isChecked";
            //             }

            //             value.previousSibling.setAttribute("data-icon-font", "A");
            //             if(!value.parentElement.classList.contains("applied")) {
            //                 value.parentElement.classList += " applied";
            //             };
            //         }
            //     }
            // }
        })
    }
    if(Cookies.get('Meal_filters') == "true"){
        [].forEach.call(document.querySelectorAll(".subcategorieslist"), function(ele){
            checkedparent = ele.classList;
            subcat_count = document.querySelector("." + checkedparent[0]).querySelectorAll(".subcatname.isChecked").length;

            if (subcat_count > 0) {
                document.querySelector(".cls_" + checkedparent[0].split("sub")[1]).querySelector(".subcatCount").innerHTML = (subcat_count + " Selected");
            }
            else {
                document.querySelector(".cls_" + checkedparent[0].split("sub")[1]).querySelector(".subcatCount").innerHTML = '';
            }
        });
    }
}
export function addIngrediants(id, isChecked, ingredient, flag, eleRef, recId1, isApp, recName) {
    if(isApp && flag=="RL"){
        var obj={};
        obj.gaObj = "Meal Planner | Recipe Detail Page Actions_Add Ingredient";
            // "eventdata": {
            //     "event_action": "Add Ingredient",
            //     "event_label": ""
            // }
        trackEvent(obj);
    }
    service.showLoader();
    if (isChecked == 0) {
        isChecked = 1;
    } else {
        isChecked = 0;
    }
    if (flag == "GL") {
        // var url = global.api_url + "dietplan/updategrocerylist";
        var url = global.api_ci_url + "MealPlanner/updateGrocerylist";
        var recId = recId1;
    } else {
        var url = global.api_ci_url + "MealPlanner/addIngrediantGrocery";
        var recId = recId1;
        // var url = global.api_url + "dietplan/addingredianttogrocerylist";
    }
    var tempGroceryObj = {
        "ingredient": ingredient,
        "isChecked": isChecked,
        "id": id
    }
    var postData = {
        "recipeid": recId,
        "tempGroceryObj": tempGroceryObj
    }
    service.postServiceCall(url, postData).then((json) => {
        if (flag == "GL") {
            if (json['msg'] == 1) {
                // eleRef.setState({ ingredientsArr: json['result'].groceryListArr });
                eleRef.changeData(recId, "removeList", isChecked, json['result'].groceryListArr);
                document.querySelector(".alertmsg").innerHTML = "Removed from Grocery List";
                document.querySelector('.alertMsg-overlay').style.display = "block";
                setTimeout(() => {
                    document.querySelector('.alertMsg-overlay').style.display = "none";
                }, 1000);
            }
        } else {
            if (json['msg'] == 1) {
                eleRef.setState({ ingredientsArr: json['result'].ingredientsArr });
                if (isChecked == 1) {
                    document.querySelector(".alertmsg").innerHTML = "Added in Grocery List";

                    if(isApp){
                        let appGTMJson = {
                            "appurl": [
                                {
                                  "pagetype": "appGaEvent",
                                  "EventType": "appGaEvent",
                                  "gaEvent": "",
                                  "gajsonEvent": {
                                    "recipe_id": recId1,
                                    "recipe_name": recName,
                                    "action_type":"grocery added",
                                    "shared_platform":""
                                  },
                                  "webengageEvent": {
                                    "eventname": "bmp_detail_page_actions",
                                    "eventdata": {
                                        "recipe_id": recId1,
                                        "recipe_name": recName,
                                        "action_type":"grocery added",
                                        "shared_platform":"",
                                        "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                                    }
                                  },
                                  "jarvisEvent": {
                                    "eventname": "bmp_detail_page_actions",
                                    "eventdata": {
                                        "recipe_id": recId1,
                                        "recipe_name": recName,
                                        "action_type":"grocery added",
                                        "shared_platform":""
                                    }
                                  }
                                }
                              ]
                            }; 
                            service.jsontracker(JSON.stringify(appGTMJson));
                    }
                    
                }else{
                    document.querySelector(".alertmsg").innerHTML = "Removed from Grocery List";
                    if(isApp){
                        let appGTMJson = {
                            "appurl": [
                                {
                                  "pagetype": "appGaEvent",
                                  "EventType": "appGaEvent",
                                  "gaEvent": "",
                                  "gajsonEvent": {
                                    "recipe_id": recId1,
                                    "recipe_name": recName,
                                    "action_type":"grocery removed",
                                    "shared_platform":""
                                  },
                                  "webengageEvent": {
                                    "eventname": "bmp_detail_page_actions",
                                    "eventdata": {
                                        "recipe_id": recId1,
                                        "recipe_name": recName,
                                        "action_type":"grocery removed",
                                        "shared_platform":"",
                                        "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                                    }
                                  },
                                  "jarvisEvent": {
                                    "eventname": "bmp_detail_page_actions",
                                    "eventdata": {
                                        "recipe_id": recId1,
                                        "recipe_name": recName,
                                        "action_type":"grocery removed",
                                        "shared_platform":""
                                    }
                                  }
                                }
                              ]
                            }; 
                            service.jsontracker(JSON.stringify(appGTMJson));
                    }
                }
                document.querySelector('.alertMsg-overlay').style.display = "block";
                // var deepjson = {
                //     "appurl": [{
                //         "pagetype": "Ingredientupdated",
                //         "withyposition": window.scrollY && window.scrollY + 4
                //     }]
                // }
                // service.jsontracker(JSON.stringify(deepjson));
                setTimeout(() => {
                    // window.scrollTo(0, (window.scrollY+2));
                    document.querySelector('.alertMsg-overlay').style.display = "none";
                }, 1000);
            }
        }
        service.hideLoader();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}
export function likeArticle(artiID, stageId, e, likecount, viewcnt, arttitle, flag, status, eleRef, isApp, Landingflag) {
    console.log("json===============>");
    let cls = e.target;
    console.log("Meal planner Article like Ftk========>", global.ftk);
    if(isApp && (Landingflag == "MealLanding" || Landingflag=="article" || Landingflag=="Recipe" || Landingflag=="recipeDetails" || Landingflag=="bookmarks")){
        var loginStatus= (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
        var nameType= (Landingflag == "MealLanding") ? 'Homepage Actions' :(Landingflag=="recipeDetails")? 'Recipe Detail Page Actions' : 'Listing Page Actions';
        var likeName= (Landingflag == "MealLanding") ? 'Like Recipe' : 'Like';
        var EventName =(Landingflag == "MealLanding" || Landingflag == "article") ? 'Meal Planner| ' + loginStatus + '|Homepage Actions' : (Landingflag=="recipeDetails")? 'Meal Planner | Recipe Detail Page Actions':(Landingflag=="Recipe")?'Meal Planner |Listing Page Actions':'Meal Planner|Bookmark Page Actions' ;

        if(Landingflag == "MealLanding"){

            let isToggleSet;
            let mainContainer = e.target.closest(".mealrecipe-main");
            let menuDays = mainContainer?.querySelector(".meal-menu-days");

                if(document.querySelector(".online-toggle").classList.contains("show-non-veg")){
                    isToggleSet="Off";
                }else{
                    isToggleSet="On";
                }
            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                        "veg_toggle": isToggleSet,
                        "recipe_id":stageId,
                        "recipe_name":e.target.closest(".mealrecipe-main").querySelector(".box-title").innerHTML,
                        "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                        "day":menuDays ? menuDays.innerHTML : '',
                        "shared_platform":"",
                        "article_id":"",
                        "article_name":"",
                        "action_type": "like",
                        "page_type":"baby meal palnner"
                      },
                      "webengageEvent": {
                        "eventname": "bmp_homepage_actions",
                        "eventdata": {
                            "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                            "veg_toggle": isToggleSet,
                            "recipe_id":stageId,
                            "recipe_name":e.target.closest(".mealrecipe-main").querySelector(".box-title").innerHTML,
                            "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                            "day":menuDays ? menuDays.innerHTML : '',
                            "shared_platform":"",
                            "article_id":"",
                            "article_name":"",
                            "action_type": "like",
                            "page_type":"baby meal palnner",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_homepage_actions",
                        "eventdata": {
                            "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                            "veg_toggle": isToggleSet,
                            "recipe_id":stageId,
                            "recipe_name":e.target.closest(".mealrecipe-main").querySelector(".box-title").innerHTML,
                            "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                            "day":menuDays ? menuDays.innerHTML : '',
                            "shared_platform":"",
                            "article_id":"",
                            "article_name":"",
                            "action_type": "like",
                            "page_type":"baby meal palnner"
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));

        }

        if(Landingflag == "recipeDetails"){

            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "recipe_id": stageId,
                        "recipe_name": arttitle,
                        "action_type":"like",
                        "shared_platform":""
                      },
                      "webengageEvent": {
                        "eventname": "bmp_detail_page_actions",
                        "eventdata": {
                            "recipe_id": stageId,
                            "recipe_name": arttitle,
                            "action_type":"like",
                            "shared_platform":"",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_detail_page_actions",
                        "eventdata": {
                            "recipe_id": stageId,
                            "recipe_name": arttitle,
                            "action_type":"like",
                            "shared_platform":""
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));
            
        }



        var EventAction = (flag == "article") ? 'Article Like' : likeName;
        var obj={};
        obj.gaObj = EventName + '_' + EventAction;
            // "eventdata": {
            //   "event_action": EventAction,
            //   "event_label": ""
            // }
        trackEvent(obj);
    }
    if (global.ftk !== '') {
        service.showLoader();
        if (flag == "article") {
            var postData = {
                "stageId": stageId,
                "articleId": artiID,
                "actionStatus": "1"
            }
            // var url = global.api_ci_url + "DietplanBaby/getLikeAction";
            var url ="https://parenting.firstcry.com/parenting/DietplanBaby/getLikeAction";

        } else {
            var postData = {
                "recipeid": stageId,
                "status": status
            }
            var url = global.api_ci_url + "MealPlanner/getMealLikeAction";
            // var url = global.api_url + "dietplan/setrecipeuserlike";

        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['result'] == "success") {
                if (flag != "article") {
                    eleRef.changeData(stageId, "Like", status);
                } else {
                    cls.classList.add('active');
                    cls.nextSibling.firstElementChild.innerHTML = (++likecount);
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
        return true;
    } else {
        if (isApp) {
            loginCallBack(global.currentURL);
        } else {
            service.showAlert("Please Login");
            window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
            return false;
        }
    }
}
function loginCallBack(redirectUrl) {
    if(redirectUrl){
        var deepjson = {
            "appurl": [{
                "pagetype": "login",
                "url": "https:\/\/www.firstcry.com\/m\/login?from=app",
                "redirecturl": redirectUrl
            }]
        }
    }else{
        var deepjson = {
            "appurl": [{
                "pagetype": "login",
                "url": "https:\/\/www.firstcry.com\/m\/login?from=app"
            }]
        }
    }  
    service.jsontracker(JSON.stringify(deepjson));
}
export function loginCallBack1() {
    var deepjson = {
        "appurl": [{
            "pagetype": "login",
            "url": "https:\/\/www.firstcry.com\/m\/login?from=app"
        }]
    }
    service.jsontracker(JSON.stringify(deepjson));
}
export function setBookMark(articleId, status, flag, eleRef, isApp, recipeType, cls, recName, e) {
    console.log("Meal planner setBookMark Ftk========>", global.ftk);

    if(isApp && flag !="MealLanding" && flag != "article"){
        let appGTMJson = {
            "appurl": [
                {
                  "pagetype": "appGaEvent",
                  "EventType": "appGaEvent",
                  "gaEvent": "",
                  "gajsonEvent": {
                    "recipe_id": articleId,
                    "recipe_name": recName,
                    "action_type":"bookmark",
                    "shared_platform":""
                  },
                  "webengageEvent": {
                    "eventname": "bmp_detail_page_actions",
                    "eventdata": {
                        "recipe_id": articleId,
                        "recipe_name": recName,
                        "action_type":"bookmark",
                        "shared_platform":"",
                        "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                    }
                  },
                  "jarvisEvent": {
                    "eventname": "bmp_detail_page_actions",
                    "eventdata": {
                        "recipe_id": articleId,
                        "recipe_name": recName,
                        "action_type":"bookmark",
                        "shared_platform":""
                    }
                  }
                }
              ]
            }; 
            service.jsontracker(JSON.stringify(appGTMJson));


        var obj={};
        var eventName = ((recipeType=="Bookmarks" || recipeType=="") && status==0) ? 'Meal Planner|Bookmark Page Actions': (flag=="recipeDetails" && status==1) ? 'Meal Planner | Recipe Detail Page Actions':(flag=="Recipe" && status==1)?'Meal Planner | Listing Page Actions':'';
        var eventAction = ((recipeType=="Bookmarks" || recipeType=="") && status==0) ? 'Unbookmark': 'Shortlist';
         
        obj.gaObj = eventName + '_' + eventAction;
            // "eventdata": {
            //   "event_action": eventAction,
            //   "event_label": ""
            // }
        trackEvent(obj);
    }

    if(isApp && flag =="MealLanding" && flag != "article"){
        let isToggleSet;
                if(document.querySelector(".online-toggle").classList.contains("show-non-veg")){
                    isToggleSet="Off";
                }else{
                    isToggleSet="On";
                }
                 let mainContainer = e.target.closest(".mealrecipe-main");
            let menuDays = mainContainer?.querySelector(".meal-menu-days");
            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                        "veg_toggle": isToggleSet,
                        "recipe_id":articleId,
                        "recipe_name":recName,
                        "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                        "day":menuDays ? menuDays.innerHTML : '',
                        "shared_platform":"",
                        "article_id":"",
                        "article_name":"",
                        "action_type": "bookmark",
                        "page_type":"baby meal palnner"
                      },
                      "webengageEvent": {
                        "eventname": "bmp_homepage_actions",
                        "eventdata": {
                            "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                            "veg_toggle": isToggleSet,
                            "recipe_id":articleId,
                            "recipe_name":recName,
                            "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                            "day":menuDays ? menuDays.innerHTML : '',
                            "shared_platform":"",
                            "article_id":"",
                            "article_name":"",
                            "action_type": "bookmark",
                            "page_type":"baby meal palnner",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_homepage_actions",
                        "eventdata": {
                            "meal_category": document.querySelector(".selected-meal .meal-type").innerText,
                            "veg_toggle": isToggleSet,
                            "recipe_id":articleId,
                            "recipe_name":recName,
                            "season":e.target.closest(".mealrecipe-main").querySelector(".season-text").innerHTML,
                            "day":menuDays ? menuDays.innerHTML : '',
                            "shared_platform":"",
                            "article_id":"",
                            "article_name":"",
                            "action_type": "bookmark",
                            "page_type":"baby meal palnner"
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));

    }



    if (global.ftk != '') {
        service.showLoader();
        if (flag == "article") {
            var postData = {
                "articleId": articleId,
                "status": status.toString()
            }
            var url = global.api_ci_url + "DietplanBaby/setBookMark";
        } else {
            var postData = {
                "recipeid": articleId,
                "status": status.toString()
            }
            var url = global.api_ci_url + "MealPlanner/setMealBookMark";
            // var url = global.api_url + "dietplan/setrecipebookmark";

        }

        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                eleRef.changeData(articleId, "bookmark", status, recipeType, cls);
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
        return true;
    } else {
        if (isApp) {
            loginCallBack(global.currentURL);
        } else {
            service.showAlert("Please Login");
            window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
            return false;
        }
    }
}
export function clearMemoryImageData(eleRef, flag) {
    eleRef.setState({ isMemorySelected: flag }, () => {
        document.getElementById("upload_child").value = null;
        $('.uploadImg-overlay').hide();
        $('body').css("overflow", "visible");
        $('#cropbox').attr('src', "");
        jcrop_api = $('#cropbox').data('Jcrop');
        jcrop_api.destroy();
        var canvas = $("#preview")[0];
        var context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
        $('.img_cntner').css('width', 'auto');
        $('.img_cntner').css('height', 'auto');
        $('#cropbox').removeClass('landCropbox');
        $('#cropbox').removeClass('portCropbox');
        $('#cropbox').removeClass('normalCropbox');
        if ($(window).width() < 767) {
            $('#cropbox').width(0);
        }
    });
}
export function checkCoords(eleRef, tool) {
    var size = {
        x: parseInt($('#rx').val()),
        y: parseInt($('#ry').val()),
        w: parseInt($('#rw').val()),
        h: parseInt($('#rh').val())
    };
    var imageObj = $("#cropbox")[0];
    var canvas = $("#preview")[0];
    var context = canvas.getContext("2d");
    canvas.width = 300;
    canvas.height = 300;
    context.drawImage(imageObj, size.x, size.y, size.w, size.h, 0, 0, canvas.width, canvas.height);
    var url = canvas.toDataURL();
    var file = dataURItoFile(url, "0");
    uploadMemoryImgSubmit(file, eleRef, tool);

    // $(".loader-overlay").show();
    // var e, a = {
    //     x: parseInt($("#rx").val()),
    //     y: parseInt($("#ry").val()),
    //     w: parseInt($("#rw").val()),
    //     h: parseInt($("#rh").val())
    // };
    // (e = new Image).crossOrigin = "Anonymous", e.onload = function () {
    //     var t = $("#cropbox")[0],
    //         i = $("#preview")[0],
    //         r = i.getContext("2d");
    //     i.width = 1032, i.height = 1111, r.drawImage(t, a.x, a.y, a.w, a.h, 0, 0, i.width, i.height), r.drawImage(e, -1, -1, i.width + 2, i.height + 2), uploadMemoryImgSubmit(dataURItoFile(i.toDataURL(),"upload_child"),eleRef,tool)
    // }, e.src = $("#main_frame").attr("src")
    // }    
}
function dataURItoFile(dataURI, ids) {
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new File([ia], document.getElementById("upload_child").files[0]['name'], { type: mimeString });

}
export function dataURItoFileFB(dataURI, file_name) {
    file_name = Math.round(new Date().getTime() / 1000) + ".jpg";
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new File([ia], file_name, { type: mimeString });
}

function uploadMemoryImgSubmit(file, eleRef, tool) {
    service.showLoader();
    if (tool != "recipeDetail") {
        if ((file.type == "image/jpg" || file.type == "image/jpeg" || file.type == "image/png")) {
            var file_name = Math.round(new Date().getTime() / 1000) + ".jpg";
            $('#upload_child').parent().find('.file_upload_err_profile').css("visibility", "hidden");
            $('#upload_child').parent().find('.file_upload_err_profile').html('');
        } else {
            $('#upload_child').parent().find('.file_upload_err_profile').css("visibility", "visible");
            $('#upload_child').parent().find('.file_upload_err_profile').html('Only JPEG, JPG and PNG files allowed');
            return;
        }
    }
    var file_name = Math.round(new Date().getTime() / 1000) + "_" + file.name;
    // var apiurl = global.api_url + "uploadMemoryImage";
    var apiurl = global.api_ci_url + "MealPlanner/uploadMemoryImage";
    service.postFileServiceCall(apiurl, file, file_name).then((json) => {
        console.log(json);
        if (json['result'] == "success") {
            if (tool == "recipeDetail") {
                if (json["result"] == 'success') {
                    if (json.image_url) {
                        eleRef.setState({ uploadedSrc: json.image_url });
                    }
                    $('.file_upload_err').hide();
                    $('.file_upload_err').html("")
                } else {
                    $('.file_upload_err').show();
                    $('.file_upload_err').html(json.result);
                    eleRef.setState({ isMemorySelected: false });
                    document.getElementById("fileupload").value = null;
                    service.showAlert("Fail");
                }
            } else {
                // setCookie("uploaded_childImg", response.image_url, 30);
                $(".profile_img img").attr("src", json.image_url);
                Cookies.set('uploaded_childImg', json.image_url);
                // $("#addChildPicUrl").val(json.image_url)
                eleRef.setState({
                    cropedImagePath: json['image_url'].replace("http://", "https://")
                });
            }
            clearMemoryImageData(eleRef, true);
        }
        service.hideLoader();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}
export function afterJcropFilesLoaded(fileObj) {
    var w = 0;
    var h = 0;
    var _URL = window.URL || window.webkitURL;
    var file, img;
    file = fileObj;
    img = new Image();
    img.onload = function () {
        w = this.width;
        h = this.height;
        if ($(window).width() > 767) {
            if (w > h) {
                if ((w / h) > 2) {
                    $('#cropbox').addClass('landCropbox')
                } else {
                    $('.img_cntner').css('height', '300px');
                    $('#cropbox').addClass('portCropbox')
                }
            } else if (w < h) {
                $('.img_cntner').css('height', '300px');
                $('#cropbox').addClass('portCropbox')
            } else {
                $('.img_cntner').css('width', '300px');
                $('.img_cntner').css('height', '300px');
                $('#cropbox').addClass('normalCropbox')
            }
            if (h > 400) {
                $('.uploadImg-popup').css('top', '10%')
            }
        } else {
            if (w < h) {
                if (((($(window).width() - 40) * h) / w) > ($(window).width() - 40)) {
                    $('.img_cntner').css('height', '300px');
                    $('#cropbox').addClass('portCropbox')
                }
            }
        }
        var reader = new FileReader();
        reader.onload = function (e) {
            $('#cropbox').attr('src', e.target.result);
            $('#cropbox').Jcrop({
                aspectRatio: 464 / 500,
                setSelect: [0, 0, 200, 200],
                boxWidth: 675,
                allowResize: !0,
                onSelect: updateCoords
            })
        };
        reader.readAsDataURL(file)
    };
    img.src = _URL.createObjectURL(file);
    $('.uploadImg-overlay').show();

}
function updateCoords(c) {
    $('#x').val(c.x);
    $('#y').val(c.y);
    $('#w').val(c.w);
    $('#h').val(c.h);
    responsiveCoords(c, '#cropbox');
};
function responsiveCoords(c, imgSelector) {
    var imgOrignalWidth = $(imgSelector).prop('naturalWidth');
    var imgOriginalHeight = $(imgSelector).prop('naturalHeight');

    var imgResponsiveWidth = parseInt($('.jcrop-holder').width());
    var imgResponsiveHeight = parseInt($('.jcrop-holder').parent().height());

    var responsiveX = Math.ceil((c.x / imgResponsiveWidth) * imgOrignalWidth);
    var responsiveY = Math.ceil((c.y / imgResponsiveHeight) * imgOriginalHeight);

    var responsiveW = Math.ceil((c.w / imgResponsiveWidth) * imgOrignalWidth);
    var responsiveH = Math.ceil((c.h / imgResponsiveHeight) * imgOriginalHeight);

    $('#rx').val(responsiveX);
    $('#ry').val(responsiveY);
    $('#rw').val(responsiveW);
    $('#rh').val(responsiveH);
}
export function onChange(e, eleRef, isApp) {
    if (navigator.onLine) {
        if (isApp) {

        } else {
            var fileObj = document.getElementById("upload_child").files[0];
            if (fileObj.type.includes('image')) {
                if (fileObj) {
                    eleRef.setState({ isMemorySelected: true });
                    // document.getElementsByClassName('file_upload_err')[0].style.display = "none";
                    // document.getElementsByClassName('file_upload_err')[0].innerHTML = "";
                    if (eleRef.isJcropFilesLoaded) {
                        afterJcropFilesLoaded(fileObj);
                    } else {
                        var _eleRef = eleRef;
                        service.loadJcropFiles(_eleRef).then(function () {
                            _eleRef.isJcropFilesLoaded = true;
                            afterJcropFilesLoaded(fileObj);
                        }).catch(function () {
                            _eleRef.setState({ isMemorySelected: false });
                            document.getElementById("upload_child").value = null;
                            return false;
                        })
                    }
                } else {
                    document.getElementById("upload_child").value = null;
                    // document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                    // document.getElementsByClassName('file_upload_err')[0].style.visibility = "unset",
                    // document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                    return false;
                }
            } else {
                document.getElementById("upload_child").value = null;
                // document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                // document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                return false;
            }
        }
    } else {
        document.getElementById("upload_child").value = null;
        service.showAlert("Please Check Internet Connection!!!");
    }
}
export function appGallery(id) {
    var fname = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime();
    if (navigator.onLine) {
        var deepjson = {
            "appurl": [{
                "EventType": "uploadfile",
                "fileName": fname,
                "UniqueID": id,
                "uniqueIdForFile": id
            }]
        }
        service.jsontracker(JSON.stringify(deepjson));
    } else {
        service.showAlert("Please Check Internet Connection!!!");
    }
}
export function uploadMemory(eleRef, isApp) {
    if (global.ftk != '') {
        if (isApp) {
            var uploadedSrc1 = document.querySelector("#memoryimg").src;
        } else {
            var uploadedSrc1 = eleRef.state.uploadedSrc;
        }
        if ((!uploadedSrc1 || uploadedSrc1 == "")) {
            document.getElementsByClassName('file_upload_err')[0].style.display = "block";
            document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Upload Memory";
            return false;
        } else {
            var hostUrl = window.location.pathname;
            // var recipeId = hostUrl.split("/")[3];
            service.showLoader();
            var hostUrl = window.location.href;
            if (hostUrl.split("/")[5]) {
                var recipeId = hostUrl.split("/")[5].split("upload-recipe?")[1];
                var recipePhoto = "rePh_" + recipeId.split("&recId=")[1];
                if(recipePhoto.includes("&from=app")){
                    recipePhoto= recipePhoto.replace("&from=app","");
                }
                if (recipeId.includes("&from=app")) {
                    recipeId = recipeId.replace("&from=app", "").replace("&", "?");
                } else {
                    recipeId = recipeId.replace("&", "?");
                }
                Cookies.set(recipePhoto, uploadedSrc1);
                window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/" + recipeId);
            }
        }
    } else {
        if (isApp) {
            loginCallBack();
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
}
export function nutrionalFacts(sublistul, items, nutrionalFactsColor) {

    // setTimeout(()=>{
    var ctx = document.getElementById('myChart').getContext('2d');
    var myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
            labels: '',
            datasets: [{
                label: '# of Votes',
                data: sublistul,
                backgroundColor: nutrionalFactsColor,
                borderColor: nutrionalFactsColor,
                borderWidth: 1
            }],
        },
        options: {
            pieHole: 0.4,
            tooltips: {enabled: false},
            hover: {mode: null}
        }
    });
    // },2000);

}
export function disclClick() {
    window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/disclaimer");
}
export function feedbClick() {
    window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/feedback");
}
export function loadReadMore() {
    let readmoreAry = document.getElementsByClassName('readmore_popup');
    for (let i = 0; i < readmoreAry.length; i++) {
        let maxHeight = 60;
        let dataId = readmoreAry[i].getAttribute('data-id');
        let divHeight = document.getElementById(dataId).offsetHeight;
        if (divHeight > maxHeight) {
            document.getElementById(dataId).style.height = maxHeight + 'px';
            readmoreAry[i].style.display = "inline-block";
        }
    }
}
export function listingMenu(e, cls, flag, recipes, isApp) {
    if(isApp){
        var eventAction = '';
        var eventLable = '';
        let eventPage = '';
        if(cls=="Meal"){
            eventAction="Meal Landing";
            eventLable="Landing page";
            eventPage="Meal planner";
        }else if(cls=="Recipes"){
            eventAction="Recipes";
            eventLable="Recipes Listing page";
            eventPage="Recipes";
        }else if(cls=="Grocery"){
            eventAction="Grocery";
            eventLable="Grocery page";
            eventPage="Grocery list";
        }else{
            eventAction="Bookmark";
            eventLable="Bookmark page";
            eventPage="Bookmark";
        }

        let appGTMJson = {
            "appurl": [
                {
                  "pagetype": "appGaEvent",
                  "EventType": "appGaEvent",
                  "gaEvent": "",
                  "gajsonEvent": {
                    "nav_bar_name": eventPage
                  },
                  "webengageEvent": {
                    "eventname": "bmp_bottom_nav_bar_click",
                    "eventdata": {
                        "nav_bar_name": eventPage,
                        "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                    }
                  },
                  "jarvisEvent": {
                    "eventname": "bmp_bottom_nav_bar_click",
                    "eventdata": {
                        "nav_bar_name": eventPage
                    }
                  }
                }
              ]
            }; 
            service.jsontracker(JSON.stringify(appGTMJson));




        var obj={};
        obj.gaObj = "Meal Planner | Tab Actions_" + eventAction + "_" + eventLable;
            // "eventdata": {
            //   "event_action": eventAction,
            //   "event_label": eventLable
            // }
        trackEvent(obj);
    }
    console.log("Meal planner listingMenu Ftk========>", global.ftk);
    if (flag != "ML" && cls == "Meal") {
        window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/")
    } else if ((flag != "RL" || flag != "RDL") && cls == "Recipes") {
        if (Cookies.get("recipeType")) {
            var recipesType = Cookies.get("recipeType");
            if (recipesType == "undefined") {
                recipesType = 'Dinner';
            }
            window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/" + recipesType.replace(" ", "-").toLowerCase() + "-recipes/")
        } else {
            window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/")
        }
    } else if (flag != "GL" && cls == "Grocery") {
        // if (global.ftk != '') {
            window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/grocery-list")
        // } else {
        //     if (isApp) {
        //         loginCallBack();
        //     } else {
        //         service.showAlert("Please Login");
        //         window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
        //         return false;
        //     }
        // }
    } else if (flag != "BM" && cls == "Bookmark") {
        // if (global.ftk != '') {
            window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/bookmarks")
        // } else {
        //     if (isApp) {
        //         loginCallBack();
        //     } else {
        //         service.showAlert("Please Login");
        //         window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
        //         return false;
        //     }
        // }
    }





}
export function seeMoreClick(event, height, flag, isApp) {
    event.preventDefault();
    var previous;
    if (window.innerWidth < 767) {
        if (event.target.innerHTML == "View All" || event.target.innerHTML == "View Less" || (event.target.previousSibling && event.target.previousSibling.innerHTML == "View All") || (event.target.previousSibling && event.target.previousSibling.innerHTML == "View Less") || (event.target.children.length > 1 && event.target.children[0].innerHTML == "View All" || event.target.children.length > 1 && event.target.children[0].innerHTML == "View Less")) {
            height = '78px';
        }
    }
    if (event.target.innerHTML == "See More" || event.target.innerHTML == "Read More" || event.target.innerHTML == "View All" || (event.target.previousSibling && event.target.previousSibling.innerHTML == "View All") || (event.target.children.length > 1 && event.target.children[0].innerHTML == "View All")) {
        if(isApp){
            var eventAction = (flag=="reviews")?'Read More':(flag=="detailsPageHealth") ? 'See More|Health Benefits':(flag=="detailsPageGuide") ? 'See More|Buying Guide':'See More';
            var eventName = (flag=="reviews")?'Meal Planner | Review Page Actions':'Meal Planner | Recipe Detail Page Actions';
            var obj={};
            obj.gaObj = eventName + '_' + eventAction;
                // "eventdata": {
                //     "event_action": eventAction,
                //     "event_label": ""
                // }
            trackEvent(obj);
        }
        if (event.target.innerHTML == "Read More") {
            event.target.innerHTML = "Read Less";
            previous = event.target.parentNode.previousSibling;
        } else if (event.target.innerHTML == "View All" || event.target.previousSibling.innerHTML == "View All" || (event.target.children.length > 1 && event.target.children[0].innerHTML == "View All")) {
            if (event.target.previousSibling != null && event.target.previousSibling.innerHTML == "View All" || (event.target.children.length > 1 && event.target.children[0].innerHTML == "View All")) {
                if (event.target.previousSibling != null && event.target.previousSibling.innerHTML == "View All") {
                    event.target.previousSibling.innerHTML = "View Less";
                } else {
                    event.target.children[0].innerHTML = "View Less";
                }
                document.querySelector('.dwnIcon').attributes[0].value = "n";
            } else {
                event.target.innerHTML = "View Less";
                document.querySelector('.dwnIcon').attributes[0].value = "n";
            }
            // previous = event.target.parentElement.parentNode.previousElementSibling
            previous = event.target.parentElement.previousElementSibling;
            if ((event.target.children.length > 1 && event.target.children[0].innerHTML == "View Less")) {
                previous = event.target.previousSibling;
            }
        } else {
            event.target.innerHTML = "See Less";
            previous = event.target.previousSibling;
        }
        previous.style.overflow = "auto";
        previous.style.height = "auto";
        previous.style.maxHeight = "none";
        // previous.querySelector("span").style.display = "block";
        if (event.target.innerHTML == "View Less" || (event.target.previousSibling && event.target.previousSibling.innerHTML == "View Less") || (event.target.children.length > 1 && event.target.children[0].innerHTML == "View Less")) {
            // previous.querySelector("div").style.display = '-webkit-box';
        } else {
            previous.querySelector("span").style.display = '-webkit-box';
        }
    } else {
        if (event.target.innerHTML == "Read Less") {
            event.target.innerHTML = "Read More";
            previous = event.target.parentNode.previousSibling;
        } else if (event.target.innerHTML == "View Less" || (event.target.previousSibling && event.target.previousSibling.innerHTML == "View Less") || (event.target.children.length > 1 && event.target.children[0].innerHTML == "View Less")) {
            if (event.target.previousSibling != null && event.target.previousSibling.innerHTML == "View Less" || (event.target.children.length > 1 && event.target.children[0].innerHTML == "View Less")) {
                if (event.target.previousSibling != null && event.target.previousSibling.innerHTML == "View Less") {
                    event.target.previousSibling.innerHTML = "View All";
                } else {
                    event.target.children[0].innerHTML = "View All";
                }

                document.querySelector('.dwnIcon').attributes[0].value = "f";
            } else {
                event.target.innerHTML = "View All";
                document.querySelector('.dwnIcon').attributes[0].value = "f";
            }
            // previous = event.target.parentElement.parentNode.previousElementSibling
            previous = event.target.parentElement.previousElementSibling
            if ((event.target.children.length > 1 && event.target.children[0].innerHTML == "View All")) {
                previous = event.target.previousSibling;
            }
        } else {
            event.target.innerHTML = "See More";
            previous = event.target.previousSibling;
        }
        previous.style.overflow = "hidden";
        previous.style.height = "auto";
        previous.style.maxHeight = height;
        if (event.target.innerHTML == "View All" || (event.target.previousSibling && event.target.previousSibling.innerHTML == "View All") || (event.target.children.length > 1 && event.target.children[0].innerHTML == "View All")) {
            previous.querySelector("div").style.display = "block";
        } else {
            previous.querySelector("span").style.display = "block";
        }
    }
}
export function loadCallbackFile() {
    new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/callbacks-V1.js?v2.9";
        script.addEventListener('load', function () { resolve(); });
        script.addEventListener('error', function (e) { reject(e); });
        document.body.appendChild(script);
    }).then(function () {
        console.log("loaded callbacks.js");
    }).catch(function () {
        console.log("error loading callbacks.js");
    })
}
export function trackEvent(obj) {
    var gaObj = (obj && obj.gaObj) ? obj.gaObj : "";
    // var appsflyerObj = (obj && obj.appsflyerObj) ? obj.appsflyerObj : {};
    var webengageObj = (obj && obj.webengageObj) ? obj.webengageObj : {};
  
    var deepjson = {
      "appurl": [{
        "pagetype": "appGaEvent",
        "EventType": "appGaEvent",
        "gaEvent": gaObj,
        "webengageEvent": webengageObj
      }]
    };
    jsontrackerGA(JSON.stringify(deepjson));
  }
export function jsontrackerGA(val) {
    console.log(val);
    if (window.MobileBridge) {
      window.MobileBridge.callBackReorder(val);
      return true;
    } else if (/iphone|ipod|ipad/.test(window.navigator.userAgent.toLowerCase())) {
      setTimeout(() => {
        // var iOSAppScheme = 'FirstcryCarnival';
        // var iOSAppAction = 'CarnivalActionType';
        // var escapedJsonParameters = encodeURI(val);
        // var url = iOSAppScheme + '://' + iOSAppAction + '#' + escapedJsonParameters;
        // url = url.replace('%20', ' ');
        // document.location.href = url;
        window.webkit.messageHandlers.cookieStatus.postMessage(val);
      }, 500);
      return true;
    } else {
      return false;
    }
  }
  
